import React, { Component } from 'react';
import classNames from 'classnames';

import { Divider } from '@eventbrite/eds-divider';

import ImageContainer from './ImageContainer';
import PrimaryContent from './PrimaryContent';
import SubContent from './SubContent';
import EventCardActions from './EventCardActions';
import ExtraContent from './ExtraContent';
import Flag from './Flag';
import { PromotedLabel } from '../PromotedLabel';

import {
    LIST_TYPE,
    EVENT_CARD_PROPTYPES,
    MINI_STYLE,
    IMAGE_STYLE_FIXED,
} from './constants';

import './listEventCardContent.scss';

const ExtraContentContainer = ({ imageStyle, style, extraContent }) => {
    let component = null;

    if (imageStyle === IMAGE_STYLE_FIXED && style !== MINI_STYLE) {
        component = (
            <div className="eds-show-up-sm">
                <ExtraContent extraContent={extraContent} />
            </div>
        );
    }

    return component;
};

const DividerComponent = ({ shouldShowDivider }) => {
    let component = null;

    if (shouldShowDivider) {
        component = (
            <div className="eds-event-card-content__divisor eds-l-pad-vert-4">
                <Divider color="ui-orange" />
            </div>
        );
    }

    return component;
};

const ListEventCardContentContainer = ({
    extraContent,
    title,
    subtitle,
    description,
    onClick,
    linkUrl,
    linkAlt,
    style,
    shouldShowDivider,
    subContentOne,
    subContentTwo,
    subContentThree,
    subContentFour,
    secondaryIconType,
    isTargetBlank,
    isNoFollow,
    useSmallPadding,
    isPromoted,
}) => (
    <div
        className={classNames(
            'eds-event-card-content__content-container',
            {
                'eds-event-card-content__content-container--small-padding':
                    useSmallPadding,
            },
            'eds-l-pad-right-4',
        )}
    >
        <div className="eds-event-card-content__content">
            <ExtraContent content={extraContent} />

            {isPromoted && <PromotedLabel isPromoted={isPromoted} />}
            <div className="eds-event-card-content__content__principal">
                <PrimaryContent
                    title={title}
                    subtitle={subtitle}
                    description={description}
                    onClick={onClick}
                    linkUrl={linkUrl}
                    linkAlt={linkAlt}
                    isTargetBlank={isTargetBlank}
                    isNoFollow={isNoFollow}
                    style={style}
                    type={LIST_TYPE}
                />
                <DividerComponent shouldShowDivider={shouldShowDivider} />

                <SubContent
                    subContentOne={subContentOne}
                    subContentTwo={subContentTwo}
                    subContentThree={subContentThree}
                    subContentFour={subContentFour}
                    hasTwoActionButtons={secondaryIconType}
                />
            </div>
        </div>
    </div>
);

export default class ListEventCardContent extends Component {
    static propTypes = {
        ...EVENT_CARD_PROPTYPES,
    };

    render() {
        const {
            id,
            style,
            imageStyle,
            imageUrl,
            isLazyImage,
            imageAlt,
            shouldHideImage,
            placeholderBgColor,
            onClick,
            onFocus,
            onBlur,
            linkUrl,
            title,
            subtitle,
            description,
            flag,
            flagDark,
            shouldShowDivider,
            subContentOne,
            subContentTwo,
            subContentThree,
            subContentFour,
            extraContent,
            primaryIconType,
            primaryIconStyle,
            primaryIconTitle,
            primaryIconOnClick,
            secondaryIconType,
            secondaryIconStyle,
            secondaryIconTitle,
            secondaryIconOnClick,
            shouldShowIcons,
            containerSpacingClasses,
            isTargetBlank,
            isNoFollow,
            isPromoted,
            focused,
            useSmallPadding,
            showLikesTooltip,
            saved,
        } = this.props;

        const classes = classNames(
            containerSpacingClasses,
            'eds-event-card-content',
            'eds-event-card-content--list',
            `eds-event-card-content--${style}`,
            `eds-event-card-content--${imageStyle}`,
            {
                'eds-event-card-content--focused': focused,
            },
        );

        let imageContainer = null;

        if (!shouldHideImage) {
            imageContainer = (
                <div className="image-action-container">
                    <ImageContainer
                        onClick={onClick}
                        linkUrl={linkUrl}
                        imageUrl={imageUrl}
                        isLazyImage={isLazyImage}
                        imageAlt={imageAlt}
                        imageStyle={imageStyle}
                        flag={flag}
                        flagDark={flagDark}
                        style={style}
                        placeholderBgColor={placeholderBgColor}
                        isTargetBlank={isTargetBlank}
                        isNoFollow={isNoFollow}
                    />
                    <EventCardActions
                        id={id}
                        primaryIconType={primaryIconType}
                        primaryIconStyle={primaryIconStyle}
                        primaryIconTitle={primaryIconTitle}
                        primaryIconOnClick={primaryIconOnClick}
                        secondaryIconType={secondaryIconType}
                        secondaryIconStyle={secondaryIconStyle}
                        secondaryIconTitle={secondaryIconTitle}
                        secondaryIconOnClick={secondaryIconOnClick}
                        shouldShowIcons={shouldShowIcons}
                        isListCard={true}
                        showLikesTooltip={showLikesTooltip}
                        saved={saved}
                    />
                </div>
            );
        }

        return (
            <article
                className={classes}
                onFocus={onFocus}
                onBlur={onBlur}
                role="presentation"
            >
                <ExtraContentContainer
                    imageStyle={imageStyle}
                    style={style}
                    extraContent={extraContent}
                />
                <ListEventCardContentContainer
                    extraContent={extraContent}
                    title={title}
                    subtitle={subtitle}
                    description={description}
                    onClick={onClick}
                    linkUrl={linkUrl}
                    linkAlt={imageAlt}
                    isPromoted={isPromoted}
                    isTargetBlank={isTargetBlank}
                    isNoFollow={isNoFollow}
                    style={style}
                    shouldShowDivider={shouldShowDivider}
                    subContentOne={subContentOne}
                    subContentTwo={subContentTwo}
                    subContentThree={subContentThree}
                    subContentFour={subContentFour}
                    primaryIconType={primaryIconType}
                    primaryIconStyle={primaryIconStyle}
                    primaryIconTitle={primaryIconTitle}
                    primaryIconOnClick={primaryIconOnClick}
                    secondaryIconType={secondaryIconType}
                    secondaryIconStyle={secondaryIconStyle}
                    secondaryIconTitle={secondaryIconTitle}
                    secondaryIconOnClick={secondaryIconOnClick}
                    shouldShowIcons={shouldShowIcons}
                    useSmallPadding={useSmallPadding}
                />
                {imageContainer}
                <Flag flag={flag} flagDark={flagDark} />
            </article>
        );
    }
}
